import { useContext } from "react";
import { Typography, Box, styled } from "@mui/material";
import { Delete } from '@mui/icons-material';

import { API } from '../../../service/api';
import { DataContext } from "../../../context/DataProvider";

const Component = styled(Box)`
    margin-top: 30px;
    background: #F5F5F5;
    padding: 10px;
    border-radius: 5px;
`;

const Container = styled(Box)`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
`;

const Name = styled(Typography)`
    font-weight: 600;
    font-size: 18px;
    margin-right: 20px;
`;

const StyledDate = styled(Typography)`
    font-size: 14px;
    color: #878787;
`;

const DeleteIcon = styled(Delete)`
    margin-left: auto;
    cursor: pointer;
    color: red;
`;

const Comment = ({ comment, setToggle }) => {
    const { account } = useContext(DataContext);
    
    const removeComment = async () => {
        try {
            let response = await API.deleteComment(comment._id);
            if (response.isSuccess) {
                setToggle(prev => !prev);
                
            } else {
                console.error("Error deleting comment:", response);
            }
        } catch (error) {
            console.error("Error deleting comment:", error);
        }
    };

    return (
        <Component>
            <Container>
                <Name>{comment.name}</Name>
                <StyledDate>{new Date(comment.date).toDateString()}</StyledDate>
                {comment.name === account.username && <DeleteIcon onClick={removeComment} />}
            </Container>
            <Typography>{comment.comments}</Typography>
        </Component>
    );
};

export default Comment;
